"use client";

import { CcSeoProcess } from "@/components/services/seo/CcSeoProcess";
import type { SeoPageCopy } from "@/components/services/seo/seo-page-copy";

import { AI_PROCESS_ILLUSTRATIONS } from "./ai-process-illustrations";

/**
 * The process section with the AI visibility drawings. A client wrapper,
 * because drawing components can't be passed as props from the server view.
 */
export function CcAiProcess({ copy }: { copy: SeoPageCopy["process"] }) {
  return <CcSeoProcess copy={copy} illustrations={AI_PROCESS_ILLUSTRATIONS} />;
}
